import { render, staticRenderFns } from "./dandelion-product-detail.vue?vue&type=template&id=0e1c9000&scoped=true&"
import script from "./dandelion-product-detail.vue?vue&type=script&lang=js&"
export * from "./dandelion-product-detail.vue?vue&type=script&lang=js&"
import style0 from "./dandelion-product-detail.vue?vue&type=style&index=0&id=0e1c9000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1c9000",
  null
  
)

export default component.exports